define('module/AboutModule',['require','marionette','model/CompanyModel','view/module/AboutView'],function (require) {

    var Marionette = require('marionette');
    var CompanyModel = require('model/CompanyModel');
    var AboutView = require('view/module/AboutView');

    /**
     * Controller for reviews module
     *
     * @class ReviewModule
     */
    return Marionette.Object.extend({

        _regions: {
            about: '#sb_about_module'
        },
        _model: null,
        _layout: null,
        _view: null,

        /**
         * Inits instance
         */
        initialize: function () {
            this._layout = this.getOption('layout');

            Backbone.Wreqr.radio.channel('page').vent.on(
                'shown', _.bind(this._initView, this)
            );
        },

        /**
         * Initializes regions and views
         *
         * @private
         */
        _initView: function () {
            _.each(this._regions, function (selector, region) {
                this._layout.addRegion(region, selector);
            }, this);

            if (this._layout.about && this._layout.about.$el.length) {
                if (!this._view || this._view.isDestroyed) {
                    this._view = new AboutView({
                        model: this._getModel()
                    });
                    this._layout.about.show(this._view);
                }
            }
        },

        _getModel: function () {
            if (!this._model) {
                this._model = new CompanyModel();
                this._model.fetch();
            }
            return this._model;
        }

    });

});
